// extracted by mini-css-extract-plugin
export default {"scrollableMenu":"sider_scrollableMenu__4v9xC"};